import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowUpRightFromSquare, faCoffee, faMagnifyingGlass, faPencil, faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { GlobalService } from 'src/app/services/global/global.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { ChecklistHomePageService } from './service/checklist-home-page.service';
import { checklistInterface } from 'src/app/util/interfaces/checklist';
import { CommonModule } from '@angular/common';
import { InputWithAutocompleteModule } from '../../../page_component_item/input-with-autocomplete/input-with-autocomplete.module';
import { SearchInputModule } from 'src/app/page_component_item/search-input/search-input.module';
import { SvgGearsModule } from 'src/app/page_component_item/svg-gears/svg-gears.module';
import { searchInputTagsInterface } from 'src/app/page_component_item/search-input/search-input.component';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-checklist-home-page',
	standalone: true,
	imports: [RouterModule, FontAwesomeModule, CommonModule, InputWithAutocompleteModule, SearchInputModule, SvgGearsModule],
	templateUrl: './checklist-home-page.component.html',
	styleUrl: './checklist-home-page.component.css',
})
export class ChecklistHomePageComponent implements OnInit {
	icons = {
		faArrowUpRightFromSquare: faArrowUpRightFromSquare,
		faPencil: faPencil,
		faSquareCheck: faSquareCheck,
		faCoffee: faCoffee,
		faMagnifyingGlass: faMagnifyingGlass,
	};

	labels: LabelsInterface = {
		lbl_checklist: '',
		lbl_geral_inicio: '',
		lbl_geral_nome: '',
		lbl_geral_status: '',
		lbl_geral_cadastrado_por: '',
		lbl_usuario_responsavel: '',
		lbl_bul_acoes_descricao: '',
		lbl_bulletin_actions: '',
		lbl_geral_pesquisar: '',
		lbl_edocs_carregando: '',
	};

	constructor(
		private GlobalService: GlobalService,
		private LabelsService: LabelsService,
		private ChecklistHomePageService: ChecklistHomePageService
	) {}

	isLoadingLabels = true;
	isFirstLoadingChecklistTable = true;
	isLoadingChecklistTable = false;

	searchTags: searchInputTagsInterface[] = [];

	checklistTableArr: checklistInterface[] = [];

	ngOnInit(): void {
		this.finishLoading();

		this.LabelsService.getLabels()
			.subscribe({
				next: (labels) => {
					this.labels = labels;
				},
			})
			.add(() => {
				this.isLoadingLabels = false;
			});

		this.loadSearchTags();

		this.ChecklistHomePageService.getChecklistTable()
			.subscribe({
				next: (checklistTableArray) => {
					this.checklistTableArr = checklistTableArray;
				},
			})
			.add(() => {
				this.isFirstLoadingChecklistTable = false;
			});
	}

	async finishLoading() {
		await this.until(() => this.isLoadingLabels == false && this.isFirstLoadingChecklistTable == false);
	}

	until(conditionFunction: Function) {
		const poll = (resolve) => {
			if (conditionFunction()) resolve();
			else setTimeout(() => poll(resolve), 400);
		};

		return new Promise(poll);
	}

	isElementOverflown(element: HTMLElement) {
		return element.scrollWidth > element.clientWidth;
	}

	stopPropagation(e: Event): void {
		e.stopPropagation();
	}

	loadSearchTags(): void {
		this.searchTags = [
			{ tag: 'id', label: 'ID', icon: null, placeholder_label: 'ID' },
			{ tag: 'name', label: 'lbl_geral_nome', icon: null, placeholder_label: 'lbl_geral_nome' },
			{ tag: 'registered_by', label: 'lbl_geral_registrado_por', icon: null, placeholder_label: 'lbl_geral_registrado_por' },
			{ tag: 'enduser', label: 'lbl_geral_usuario', icon: null, placeholder_label: 'lbl_geral_registrado_por' },
			{ tag: 'enduser_email', label: 'lbl_email_usuario', icon: null, placeholder_label: 'lbl_email_usuario' },
			// {"tag":"enduser_department", "label":"lbl_departamento_usuario", "icon": null, "placeholder_label":"lbl_departamento_usuario"},
			{ tag: 'solution_area', label: 'lbl_geral_grupo', icon: null, placeholder_label: 'lbl_geral_grupo' },
			{ tag: 'topic', label: 'lbl_geral_topico', icon: null, placeholder_label: 'lbl_geral_topico' },
			{ tag: 'status', label: 'lbl_geral_status', icon: null, placeholder_label: 'lbl_geral_status' },
			{ tag: 'active', label: 'lbl_geral_ativo', icon: null, placeholder_label: 'lbl_geral_ativo' },
			// {"tag":"site", "label":"lbl_geral_site", "icon": null, "placeholder_label":"lbl_geral_site"},
			// {"tag":"location", "label":"lbl_geral_localidade", "icon": null, "placeholder_label":"lbl_geral_localidade"},
		];
	}

	searchChecklist(where: searchInputTagsInterface, text: string): void {
		this.isLoadingChecklistTable = true;
		const whereTag = where && where.tag ? where.tag : 'general';
		this.ChecklistHomePageService.getChecklistTable(whereTag, text)
			.subscribe({
				next: (checklistTableArray) => {
					this.checklistTableArr = checklistTableArray;
				},
			})
			.add(() => {
				this.isLoadingChecklistTable = false;
			});
	}
}
